import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../types/apiTypes";

export interface Meta {
  mailer?: boolean;
  fav_companies?: {
    companyName: string;
    companyType: string;
  }[];
  fav_vips?: string[];
  fav_hr?: string[];
}

export type UserState = {
  user: User | null;
  accessToken: string;
  meta?: Meta;
};

const initialState: UserState = {
  user: null,
  accessToken: "",
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
    updateUser(state, action: PayloadAction<User>) {

      const a = { ...state.user, ...action.payload };
      state.user = a;
    },
    setAccessToken(state, action: PayloadAction<string>) {
      state.accessToken = action.payload;
    },
    setData(state, action: PayloadAction<UserState>) {
      state.user = action.payload.user;
      state.accessToken = action.payload.accessToken;
    },
    setMeta(state, action: PayloadAction<Meta>) {
      const meta = action.payload;
      state.meta = { ...state.meta, ...meta };
    },
    clearState() {
      return initialState;
    },
  },
});

export const { setUser, setAccessToken, setData, clearState, updateUser } = userSlice.actions;
